import {
  Clipboard as CapacitorClipboard,
  Clipboard,
} from '@capacitor/clipboard';
import { Capacitor } from '@capacitor/core';

/**
 * @name fnCopyText
 * @description 텍스트 복사
 * @param {string} text
 * @returns {Promise<void>}
 */
export async function fnCopyText(text?: string): Promise<void> {
  /** native */
  if (Capacitor.isNativePlatform()) {
    await CapacitorClipboard.write({
      string: text,
    });
    return;
  }
  /** web */
  await Clipboard.write({
    string: text,
  });
}
